const numberToWords = (num) => {
  if (num === 0) return "zero";

  const belowTwenty = [
    "zero",
    "one",
    "two",
    "three",
    "four",
    "five",
    "six",
    "seven",
    "eight",
    "nine",
    "ten",
    "eleven",
    "twelve",
    "thirteen",
    "fourteen",
    "fifteen",
    "sixteen",
    "seventeen",
    "eighteen",
    "nineteen",
  ];

  const tens = [
    "",
    "",
    "twenty",
    "thirty",
    "forty",
    "fifty",
    "sixty",
    "seventy",
    "eighty",
    "ninety",
  ];

  const scales = ["", "thousand", "million", "billion"];

  const convertLessThanThousand = (n) => {
    if (n === 0) return "";
    if (n < 20) return belowTwenty[n];
    if (n < 100)
      return (
        tens[Math.floor(n / 10)] + (n % 10 ? "-" + belowTwenty[n % 10] : "")
      );

    return (
      belowTwenty[Math.floor(n / 100)] +
      " hundred" +
      (n % 100 ? " " + convertLessThanThousand(n % 100) : "")
    );
  };

  let words = "";
  let scaleIndex = 0;

  while (num > 0) {
    let chunk = num % 1000;
    if (chunk) {
      words =
        convertLessThanThousand(chunk) +
        (scales[scaleIndex] ? " " + scales[scaleIndex] : "") +
        " " +
        words;
    }
    num = Math.floor(num / 1000);
    scaleIndex++;
  }

  return words.trim();
};

export const amountToWords = (amount) => {
  if (!amount) return "Zero";

  const [integerPart, decimalPart] = amount.toString().split(".");

  let words = numberToWords(parseInt(integerPart));
  if (decimalPart) {
    words += ` point ${decimalPart
      .split("")
      .map((digit) => numberToWords(parseInt(digit)))
      .join(" ")}`;
  }

  return words;
};

export function getToFromDateRange(days) {
  const today = new Date();

  const startDate = new Date(today);

  const endDate = new Date(today);
  endDate.setDate(today.getDate() + (days - 1));

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  return {
    startDate: formatDate(startDate),
    endDate: formatDate(endDate),
  };
}
